/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BinocularsRegularAi from './binoculars-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BinocularsRegularAi {...validProps} />;
}
SvgComponent.iconName = 'binocularsRegularAi';

export const BinocularsRegularAiIcon = svgIconWrapper(SvgComponent);
